/*
    Copyright 2022 Dynatrace LLC

    Licensed under the Apache License, Version 2.0 (the "License");
    you may not use this file except in compliance with the License.
    You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

    Unless required by applicable law or agreed to in writing, software
    distributed under the License is distributed on an "AS IS" BASIS,
    WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
    See the License for the specific language governing permissions and
    limitations under the License.
*/

// this is autogenerated file, see scripts/gen-version.js
export const VERSIONS = {
	pkgVersion: "1.343.2",
	prereleaseTag: "20260626-045432",
	fullVersion: "1.343.2.20260626-045432",
	buildDate: "2026.06.26 04:54:32",
	commitHash: "6fa2e9b433eb76736f82a70e7e67db1d1b364c91",
	isDevVersion: false
};
